import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../components/layout/TopNav';
import HomeFooter from '../components/home/HomeFooter';

const sources = [
  {
    name: 'Movebank',
    url: 'https://www.movebank.org/',
    description: 'A free online database of animal tracking data, hosted by the Max Planck Institute of Animal Behavior.',
  },
  {
    name: 'eBird',
    url: 'https://ebird.org/',
    description: 'The world\'s largest biodiversity-related citizen science project, managed by the Cornell Lab of Ornithology.',
  },
  {
    name: 'Journey North',
    url: 'https://journeynorth.org/',
    description: 'A citizen science project tracking wildlife migration and seasonal change.',
  },
  {
    name: 'IUCN Red List',
    url: 'https://www.iucnredlist.org/',
    description: 'The world\'s most comprehensive inventory of the global conservation status of biological species.',
  },
  {
    name: 'BirdLife International',
    url: 'https://www.birdlife.org/',
    description: 'A global partnership of conservation organisations focused on bird conservation.',
  },
  {
    name: 'NOAA Fisheries',
    url: 'https://www.fisheries.noaa.gov/',
    description: 'Marine species data and migration tracking for whales, sea turtles, and fish.',
  },
  {
    name: 'WWF (World Wildlife Fund)',
    url: 'https://www.worldwildlife.org/',
    description: 'Species profiles, conservation status data, and habitat information.',
  },
  {
    name: 'Unsplash',
    url: 'https://unsplash.com/',
    description: 'Free high-resolution wildlife photography used throughout this platform.',
  },
];

const SourcesPage = () => {
  return (
    <div className="bg-surface text-on-surface font-body min-h-screen">
      <TopNav />
      <main className="pt-32 pb-24 px-8 max-w-4xl mx-auto">
        <span className="font-label text-xs uppercase tracking-widest text-primary mb-4 block">Transparency</span>
        <h1 className="font-headline text-5xl text-on-surface mb-6 italic">Data Sources &amp; Credits</h1>
        <p className="text-on-surface-variant font-body text-lg leading-relaxed mb-16 max-w-2xl">
          Migration Journal aggregates publicly available data from the following organisations.
          We are grateful for their open data initiatives that make projects like this possible.
        </p>

        <div className="space-y-8">
          {sources.map((source) => (
            <a
              key={source.name}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-surface-container-high/40 backdrop-blur-sm p-8 rounded-2xl hover:bg-surface-container-high/60 transition-all group"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-headline text-xl text-on-surface group-hover:text-primary transition-colors mb-2">
                    {source.name}
                  </h3>
                  <p className="text-on-surface-variant text-sm font-body leading-relaxed">
                    {source.description}
                  </p>
                </div>
                <span className="material-symbols-outlined text-slate-500 group-hover:text-primary transition-colors flex-shrink-0 ml-4">
                  open_in_new
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/explorer"
            className="text-primary font-label text-sm inline-flex items-center gap-2 hover:text-primary-fixed-dim transition-colors"
          >
            <span className="material-symbols-outlined text-sm">arrow_back</span>
            Back to Explorer
          </Link>
        </div>
      </main>
      <HomeFooter />
    </div>
  );
};

export default SourcesPage;
